
import { Select, MenuItem, Checkbox, ListItemText, TextField, Box } from "@mui/material";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs, { Dayjs } from "dayjs";
import { useState, useEffect } from "react";
import { DataField, DropdownModel } from "../../data/interfaces/sharedmodels";
import { formatValue, formatValueAsReadOnly } from "../commonfunctions";
import { MenuProps } from "../commonprops";

const EditableField = ({ field, value, fieldLookups, uniqueId, callback, isEditable,width }:
    { field: DataField, value: any, fieldLookups: DropdownModel[] | undefined, uniqueId: any, 
        callback: any, isEditable: boolean,width:number }) => {
    const [currentValue, setCurrentValue] = useState(value);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (currentValue != value)
            callback(field, uniqueId, isEditing ? currentValue : value);
        if (!isEditing) {
            setCurrentValue(value);
        }
        else {
            setIsEditing(false);
        }

    })


    const handleChange = (event: any) => {
        setIsEditing(true);
        if (field.Type === "checkbox") {
            setCurrentValue(event.target.checked);
        }
        else {
            setCurrentValue(event.target.value);
        }

    }
    const handleDateChange = (value: Dayjs) => {
        setIsEditing(true);
        if (field.CustomFormat == "Time24") {
            let startHour = dayjs().startOf('day')
            setCurrentValue(value.diff(startHour, 'minute', false));
        }
        else {
            setCurrentValue( value.toDate());
        }


    }

    if ((isEditable && field.IsEditable) || uniqueId <1) {
        if (fieldLookups) {
            if (field.IsMultiSelect) {
                return (
                    <Select
                        size="small"
                        multiple
                        sx={{ width: '100%', maxWidth: '400px' }}
                        value={currentValue || [-99]}
                        renderValue={(selected) => selected.join(', ')}
                        onChange={handleChange}
                        MenuProps={MenuProps}>
                        {
                            fieldLookups.map((item) => {
                                return (
                                    <MenuItem key={item.Id} value={item.Id}>
                                        <Checkbox checked={currentValue.findIndex((a: string) => a == item.Id) > -1} />
                                        <ListItemText primary={item.Description} />
                                    </MenuItem>
                                )
                            })}


                    </Select>
                )
            }
            else {
                return (
                    <Select
                        size="small"
                        sx={{ width: '100%' }}
                        value={currentValue != null ? currentValue.toString() : "-99"}
                        onChange={handleChange}>

                        {
                            fieldLookups.map((item) => {
                                return (
                                    <MenuItem key={item.Id} value={item.Id}>{(field.LookUpShowIdDesc && item.Id != "-99") ? (item.Id + " - " + item.Description) : item.Description}</MenuItem>
                                )
                            })}


                    </Select>
                )
            }
        }
        else if (field.CustomFormat && field.CustomFormat === "Time24") {
            return (
                <div className="datepickerclass">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker ampm={false} sx={{ width: '100%' }} onChange={(value) => handleDateChange(value)} value={formatValue(currentValue, field.Type, field.CustomFormat)} />
                    </LocalizationProvider>
                </div>
            )

        }
        else if (field.Type === 'date') {
            return (
                <div className="datepickerclass" >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker sx={{ width: '100%' }} onChange={(value) => handleDateChange(value)} value={formatValue(currentValue, field.Type)} format="MMM D, YYYY" />
                    </LocalizationProvider>
                </div>
            )
        }
        else if (field.Type === 'checkbox') {
            return (
                <Checkbox size="small" sx={{ width: '100%' }} onChange={handleChange} checked={currentValue} value={formatValue(currentValue, field.Type)} />

            )
        }
        else {
            return (
                <TextField
                    size="small" sx={{ width: width>998?'100%':width,minWidth:'120px' }} onChange={handleChange} value={formatValue(currentValue, field.Type)} type={field.Type}  InputProps={{
                        inputProps: {
                            min: field.Min,
                            max: field.Max,
                            step: 1
                        },
                    }}/>

            )
        }
    }
    else {
        return (
            <Box component='div' sx={{ width: '100%', textAlign: 'center' }} >{currentValue != null && !field.IsMultiSelect && fieldLookups ?
                ((field.LookUpShowIdDesc ? currentValue + " - " : "") + fieldLookups.find(f => f.Id.toString() == currentValue)?.Description) :
                formatValueAsReadOnly(currentValue, field.Type, field.CustomFormat, field.IsMultiSelect)}</Box>
        )
    }



}

export default EditableField;